import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Analisis/cambiarAnalisisEyaculadoEliminadoSeleccion`, method: 'POST', body: {list}, token: token})
}